/* tslint:disable */

/**
 */
export class Collected {
    shifts?: number[];
}
